export default {
  paidOut: "(Uitbetaald)",
  product: "Produit",
  quantity: "Quantité",
  attributes: "Attributs",
  points: "Points",
  point: "Point",
  action: "Action",
  clear: "Supprimer",
  back: "Retour",
  save: "Enregistrer",
  close: "Fermer",
  of: "De",
  to: "à",
  copyrights: "© {date} Bridgestone Solutions. Tous droits réservés.",
  pageNotFound: "Page non trouvée",
  accessDenied: "Accès refusé",
  search: "Recherche",
  dashboard: {
    profile: {
      welcome: "Bienvenue sur",
      completeProfile: "Compléter le profil personnel et en plus",
      completeProfileBold: "Assurer 200 points.",
      link: "Afficher le profil",
      fullCompleteProfile: "Votre profil personnel est complet !",
    },
    pobox: {
      newMessages: "Nouveaux messages dans votre boîte aux lettres",
      link: "Afficher les messages",
    },
    bankstatement: {
      yourScore: "Votre score actuel :",
      lastUpdate: "Dernière mise à jour :",
      link: "Afficher l'aperçu des points",
      kickbackLink: "Aperçu des frais de kickback",
      yourKickback: "Votre nombre actuel de frais de kickback :",
    },
    showAllProducts: "Vers la boutique des primes",
  },
  pageName: {
    productInfoAndQuestions: "Brochures et Tarifs",
    preislisten: "Brochures et Tarifs",
    preislistenList: "Listes de prix",
    dashboard: "Page principale",
    trainings: "Formations",
    onlineTrainings: "Formations en ligne",
    bridgestoneSchulungen: "Formation Bridgestone",
    shop: "Boutique des primes",
    shopProducts: "Boutique des primes",
    shopCategory: "Boutique des primes",
    product: "Produit",
    productDetails: "Détails du produit",
    productInfo: "Informations sur les produits",
    pkw: "Voiture",
    motorrad: "Moto",
    lkwUndBusse: "Camions et bus",
    produktbroschuren: "Brochures sur les produits",
    pricat: "Pricat",
    landwirtschaft: "Agriculture",
    baumaschinenOtr: "Machines de chantier - Otr",
    bDrive: "Images de pneus &  logos",
    beanstandungsFormular: "Formulaire de réclamation",
    bridgestoneProduktbroschuren: "Produits Bridgestone",
    firestoneProduktbroschuren: "Produits Firestone",
    technologien: "Technologies, marquages et plus encore",
    training: "Formation",
    trainingForm: "Forme de formation",
    account: "Mon compte",
    pointsOverview: "Mon compte de points",
    stammdaten: "Mes données de base",
    mailbox: "Boîte postale",
    singleMailbox: "Message",
    bridgestoneSingleSchulungen: "Formation Bridgestone Formation",
    externeTraining: "Formations externes",
    warenkorb: "Panier d'achat",
    orderSummary: "Aperçu des commandes",
    orderDelivery: "Adresse de livraison",
    orderComplete: "Commande réussie",
    text_page: "Page statique",
    contact_service: "Contact & Service",
    sales_support: "Soutien à la vente",
    salesPromotions: "Promotion des ventes",
    productInfoAndPriceList: "Informations sur les produits & listes de prix",
    service_number: "Numéros de service",
    about: "À propos de BRIDGESTONE PLUS",
    contact_form: "Formulaire de réclamation",
    userOrders: "Mes commandes",
    userOrder: "Ta commande",
    hunterShop: "Hunter",
    wholesaler: "Tableau de bord des partenaires stratégiques",
    news_feeds: "Actualités",
    investment: "Soutien aux investissements",
    staff: "Tableau de bord",
    fuelCalculator: "Calculateur d'économies de carburant",
    myAccount: "Mon compte",
    myPoints: "Mes commandes de pneus",
    commitmentLetter: "Lettre d'engagement",
    rewardsOverview: "Explication des frais de kickback et des points",
    strategic_partners: "Contacter le distributeur",
    onlineVisibility: "Partout",
    media: "Paquets média",
    staffVouchers: "Vouchercodes",
    wholesalerVouchers: "Vouchercodes",
    brochure_prices: "Brochures produits et listes de prix",
    touch_incentive: "Contact Touch Incentive",
    favoriteProducts: "Produits favoris",
  },
  account: {
    title: "Mon compte",
    desc: "Bienvenue dans votre espace personnel. Ici, vous pouvez compléter vos données de base ou adapter <br/>, consulter votre boîte aux lettres et votre relevé de compte de points.",
    descStaff:
      "Bienvenue dans votre espace personnel. Ici, vous pouvez compléter vos données de base ou adapter <br/>, consulter votre boîte aux lettres et votre relevé de compte de points.",
    categories: {
      basedata: {
        title: "Données de base",
        desc: "Complétez ici vos coordonnées et celles de votre entreprise pour une participation réussie.",
      },
      pobox: {
        title: "Boîte postale",
        desc: "Vous trouverez les messages importants, les confirmations de commande et les nouveautés dans votre boîte aux lettres personnelle.",
      },
      bankstatement: {
        title: "Relevé de compte",
        desc: "Ici, vous pouvez consulter votre solde actuel de points de récompense et les mouvements de votre compte.",
      },
    },
  },
  profile: {
    title: "Mes données de base",
    description:
      "Bienvenue dans votre espace personnel. Ici, vous pouvez compléter ou adapter vos données de base, consulter votre boîte aux lettres et votre relevé de compte de points.",
    personalData: "Données personnelles",
    password: "Mot de passe",
    password1: "Mot de passe (au choix)*",
    password2: "Mot de passe (répétition)*",
    formOfAddress: "Titre de civilité",
    choose: "Veuillez choisir",
    mr: "Monsieur",
    mrs: "Mme",
    diverse: "Divers",
    firstname: "Prénom",
    surname: "Nom de famille",
    position: "Position dans l'entreprise",
    operatingData: "Données d'exploitation",
    company: "Société",
    legalForm: "Forme juridique",
    name: "Nom",
    streetHouseNr: "Rue et numéro",
    street: "Rue",
    postcode: "CODE POSTAL",
    location: "LIEU",
    country: "Pays",
    de: "Allemagne",
    at: "Autriche",
    ch: "Suisse",
    nl: "Pays-Bas",
    it: "Italie",
    language: "Langue",
    french: "Français",
    italian: "Italien",
    german: "Allemagne",
    nederland: "Pays-Bas",
    phone: "Téléphone",
    website: "Site web",
    operatingIndicators: "Chiffres clés de l'exploitation",
    tireSale: "Chiffre d'affaires pneus par an env. en pièces",
    tireSaleLabel: "Vendre des pneus en grande quantité",
    inches: "Dont ≥ 18 pouces (en %)",
    inchesLabel: "Dont 18 pouces et plus en %",
    segmentSale:
      "Ventes de pneus par segment (part Budget / Mid / Premium en %)",
    premBudget: "Premium",
    midBudget: "Mid",
    budBudget: "Budget",
    distribution: "RÉPARTITION ÉTÉ / HIVER / TOUTES LES SAISONS (en %)",
    tyreSizes: "Nombre de dépôts par saison (jeux de pneus)",
    diffDeliveryAddres: "Ajouter une adresse de livraison",
    yourEmailAddress: "votre adresse e-mail*.",
    clientNr: "Numéros de clients",
    clientNrSingular: "Numéro de client",
    clientNrContent:
      "<span class='text-danger fw-bold'>IMPORTANT - VEUILLEZ LIRE :</span><br /><br /> Pour l'attribution de vos commandes de pneus chez un grossiste et / ou chez Bridgestone, il est impératif que <b>vous indiquiez vos numéros de client respectifs.</b><br/><br/>Si vous <b>avez plusieurs numéros de client chez un grossiste et / ou chez Bridgestone,</b> par exemple pour votre magasin principal et vos filiales, indiquez d'abord le numéro de client du magasin principal.<br/><br/><b>Les ventes des autres numéros de client seront ensuite attribuées à votre magasin principal.</b>",
    supplySource: "Source d'approvisionnement",
    email: "Adresse électronique",
    staffEmail: "Adresse e-mail du participant",
    registered: "Enregistré le",
    registeredAt: "Enregistré le",
    lastLogIn: "Dernière connexion",
    details: "Détails",
    inDetail: "{name} en détail",
    bsClientNr: "Votre numéro de client Bridgestone",
    bftClientNr: "Votre numéro de client Best4Tires",
    acceptTerms:
      "Accepter les conditions générales et les conditions de participation.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>IMPORTANT - VEUILLEZ LIRE :</span><br />Lors de la première saisie du numéro de client, vos données sont vérifiées quant à leur exactitude et à nos critères de distribution. La décision d'activer le(s) numéro(s) de client et de le(s) relier à votre profil peut prendre jusqu'à 5 jours ouvrables.",
    selectWholeSaler: "chez le fournisseur (veuillez choisir)",
    cooperation: "MEMBRE / COOPÉRATION",
    error100: "La somme des valeurs doit être égale à 100%.",
    errorRange: "La valeur doit être comprise entre 0 et 100",
    btw_number_label: "le numéro d'identification à la TVA de votre entreprise",
    btw_number: "Numéro d'identification de la taxe sur le chiffre d'affaires",
    mobile: "NUMÉRO DE TÉLÉPHONE",
    mobile_label: "Votre numéro de téléphone (portable)",
    iban_number: "Numéro IBAN de VOTRE ENTREPRISE",
    iban_number_label: "Numéro IBAN",
    yourCsNr: "Vos numéros de client",
    yourLastName: "Votre nom de famille",
    positionLabel: "Sélectionner une position",
    yourFirstName: "Votre prénom",
    companyLabel: "Société",
    numberOfSetsOfSeasonalTiresBudget: "Stockage par an",
    contactInfo: "Si vous avez des questions, veuillez contacter:",
  },
  pobox: {
    title: "Ma boîte aux lettres",
    desc: "Bienvenue dans votre espace personnel. Ici, vous pouvez compléter ou adapter vos données de base, consulter votre boîte aux lettres et votre relevé de compte de points.",
    message: {
      sender: "Expéditeur",
      thread: "Sujet",
    },
    sender: {
      system: "BRIDGESTONE PLUS",
    },
    back: "Retour à l'aperçu",
  },
  time: {
    secondsAgo: "il y a {time} secondes",
    minutesAgo: "il y a {time} minutes",
    hoursAgo: "il y a {time} heures",
    daysAgo: "il y a {time} jours",
  },
  bankstatement: {
    title: "Mon relevé de compte personnel",
    desc: "Vous pouvez consulter ici votre relevé de compte personnel Bridgestone Plus concernant les points de récompense que vous avez obtenus et utilisés. Veuillez noter que les crédits de points pour votre commande de pneus ne seront crédités qu'au bout de 6 semaines maximum après la date de la commande, selon la source d'approvisionnement.",
    score: "Score",
    regularPoints: "Points réguliers",
    boosterPoints: "Points Booster",
    date: "Date",
    supplySourceReason: "Source d'approvisionnement / raison",
    article: "Article",
    brand: "Marque",
    product: "Produit",
    type: "Type",
    inch: "Douanes",
    season: "Saison",
    amount: "Quantité",
    standardPoints: "Points",
    boosterProduct: "Produit booster",
    boosterSeason: "Saison de booster",
    otherActions: "Autre action ou cause",
    totalPoints: "Points Total",
    income: "Entrées",
    spending: "Départs",
    lastMonth: "Situation à la fin",
    loadMore: "Charger 20 autres chiffres d'affaires",
    typeFilter: "Filtrer par source d'approvisionnement",
    dateFilter: "Filtrer par plage de dates",
    customer_number: "Numéro client",
    currentPoints: "Points actuels",
    calculationDate: "Date de calcul",
    positivePoints: "Points positifs",
    negativePoints: "Déjà dépensé",
    tyresAmount: "Pneus Quantité annuelle",
    pointsTotal: "Total des points",
    currentPointState: "Score actuel",
    currentKickbackState: "kickback actuel",
    pointsFromCurrentYear: "Ajout : points de l'année en cours ({year})",
    pointsAtRiskOfExpiry: "Points à dépenser avant le 31.03.{year}",
  },
  shop: {
    variant: "Variantes sélectionnables",
    description:
      "Bienvenue dans la boutique des primes. Ici, vous pouvez échanger vos points Bridgestone Plus <br/> contre des primes de différentes catégories. L'offre de produits <br/> est régulièrement mise à jour. Nous vous souhaitons beaucoup de plaisir à fouiller.",
    selectedProducts: "Produits sélectionnés",
    selectedAddress: "Adresse sélectionnée",
    noProducts: "Les critères de recherche n'ont donné aucun résultat",
    placeOrder: "Commander obligatoirement",
    toOrderDelivery: "Continuer vers l'adresse de livraison",
    toOrderSummary: "Vers l'aperçu des commandes",
    emptyCart: "Le panier est vide.",
    pointsTotal: "Total des points",
    productImg: "Image du produit",
    selectAddressBtn: "Sélectionner l'adresse",
    selectAddressP: "Veuillez sélectionner votre adresse de livraison",
    notEnoughPoints: "Pas assez de points disponibles.",
    outOfStock: "Actuellement pas en stock",
    timeUnavailable: "Actuellement non disponible",
    productUnavailable: "Ce produit n'est plus disponible.",
    deletedProductsTitle: "Produits non disponibles",
    deletedProductsMessage:
      "Les produits suivants ne sont plus disponibles. Veuillez les retirer de votre panier pour continuer.",
    removeSelected: "Supprimer la sélection",
    clearCart: "Vider le panier",
    removeSelectedConfirm: "Supprimer les produits sélectionnés de votre panier ?",
    clearCartConfirm: "Supprimer tous les produits de votre panier ?",
    cart: {
      pointsPerUnit: "Points / unité",
      pointsSum: "Points",
    },
    sort: {
      asc: "Trier par : Prix le plus bas",
      desc: "Trier par : Prix le plus élevé",
    },
    perPgae: "Articles par page",
    categories: {
      advertising: {
        title: "Matériel publicitaire",
        desc: "Participez directement ici sur la plate-forme et obtenez <br/> 40 points supplémentaires pour le club de primes.",
      },
      rewards: {
        title: "Primes exclusives",
        desc: "Découvrez l'offre de primes  <br/>dans notre centre de formation ou dans vos locaux.",
      },
      tools: {
        title: "Outils d'atelier",
        desc: "Utilisez vos points pour des formations tierces <br/> et réduisez ainsi vos coûts.",
      },
      trainings: {
        title: "Formations et cours",
        desc: "Découvrez l'offre de primes dans notre centre de formation ou dans vos locaux.",
      },
      salesroom: {
        title: "Espace de vente",
        desc: "Mettre en scène l'espace de vente et offrir à votre client un séjour agréable.",
      },
      hunter: {
        title: "Hunter",
        desc: "Échanger des points contre de l'équipement d'atelier attrayant de Hunter.",
      },
    },
    bestSold: "Les plus achetés",
    seasonal: "De saison",
    affordable: "On y est presque",
    forPoints: "pour {points} points",
    reachedPoints: "Score requis atteint",
    cartRemainPoints: "Points restants",
    remainingPoints: "{points} Points restants",
  },
  externeTraining: {
    title: "Formations externes",
    description:
      "Assurez-vous de bénéficier de l'expertise d'un expert et, en cas de réussite aux tests de la formation, de recevoir votre certificat de participation personnel ainsi que 40 points supplémentaires pour le club de primes.",
    additionalInfo:
      "Outre nos formations en ligne gratuites et nos formations Bridgestone payantes, nous vous offrons également la possibilité de financer ou de subventionner des formations externes avec vos points de récompense - en fonction de votre crédit.",
    itsEasy: "C'est aussi simple que ça :",
    excludeText:
      "Nous vous prions de comprendre que les offres de concurrence directe sont exclues.",
    downloadSection: {
      title: "Télécharger le modèle de facture",
      description1:
        "Téléchargez ici un modèle pour le décompte de vos points à notre intention.",
      description2:
        "Sur l'exemple, vous trouverez toutes les indications nécessaires.",
    },
    form: {
      title: "Demande",
      thirdPartyInvoice: "Facture de tiers",
      userInvoice: "Ma facture",
      bankAccountOwner: "Titulaire du compte",
      uploadInvoice: "Télécharger ma facture de points engagés",
      have: "Je souhaite",
      thirdPartyInvoiceDesc:
        "Points dans un %{calculatePriceDiscount} CHF de pour les suivants",
      userInvoiceDesc:
        "Utiliser la facture de formation, télécharger la facture d'un tiers",
    },
    info: {
      paragraph1:
        "Vous participez vous-même ou votre équipe à une formation technique dispensée par un prestataire tiers.",
      paragraph2: "Ils compensent la facture du fournisseur tiers.",
      paragraph3:
        'Vous faites une demande de subvention sur cette page dans le champ "demande"',
      elements: {
        first: "Télécharger la facture du prestataire tiers",
        second:
          "Inscrire le montant des points que vous souhaitez utiliser (au maximum à hauteur du montant net de la facture)",
        third:
          "Vous établissez une facture de votre entreprise à hauteur des points utilisés (0,25 CHF net par point) et les télécharger également",
        fourth: "Les factures et la demande sont examinées",
        fifth: "Vous recevez un paiement correspondant aux points mis en jeu",
      },
    },
    success: {
      title: "Merci beaucoup",
      paragraph: {
        first: "Votre demande a été reçue.",
        second:
          "Après un examen positif, vous recevrez le remboursement du montant des points utilisés, crédité sur le compte indiqué.",
        third: "L'examen et le paiement peuvent prendre jusqu'à 6 semaines.",
        fourth:
          "Nous avons réduit votre compte de points du montant des points utilisés.",
        fifth: "Vous trouverez une copie de la demande dans votre",
      },
    },
  },
  buttons: {
    toSearch: "Rechercher",
    sendRequest: "Envoyer une demande",
    formButton: "vers le formulaire",
    discoverButton: "découvrir",
    sendButton: "Envoyer",
    makeContact: "Prendre contact",
    userProfile: "Vers vos données de base",
    userOrders: "Vers vos commandes",
    mailbox: "Vers la boîte postale",
    pointsList: "Vers le relevé de compte",
    next: "Continuer",
    back: "RETOUR",
    skip: "Sauter",
    toTheBasket: "Ajouter au panier",
    edit: "Modifier",
    cancel: "Annuler",
    select: "Sélectionner",
    newOrder: "Nouvelle commande",
    downloadAll: "Télécharger tout",
    readNow: "Lire maintenant",
    toDashboard: "Vers la page d'accueil",
    moreCustomerNumbers: "+ indiquer d'autres numéros de clients",
    toProductInfo: "DÉCOUVRIR LES INFORMATIONS SUR LES PRODUITS",
    toAccount: "VERS LE COMPTE DE POINTS",
    toSalesPromotions: "INSCRIVEZ VOTRE ENTREPRISE MAINTENANT",
    show: "DÉCOUVRIR MAINTENANT",
    toOnlineTrainings: "VERS LES FORMATIONS EN LIGNE",
    newAddress: "Créer une nouvelle adresse de livraison",
    toQuiz: "Vers le quiz",
    toDownload: "vers le téléchargement",
    calculate: "Calculer",
    reset: "Nouveau calcul",
    register: "S'inscrire",
    refuseBtn: "RENONCIER",
    acceptBtn: "ACCEPTER",
    toCommitmentLetter: "VERS LA LETTRE D'ENGAGEMENT",
    toKickbackFeeInfo: "EXPLICATION DES FRAIS ET DES POINTS",
    clickHere: "Voir les détails",
    directBuy: "Commander directement",
    toDiscover: "Découvrir",
    dealerInfoDownload: "TÉLÉCHARGER LES INFORMATIONS POUR LES REVENDEURS",
    all: "Tous",
    clearFilters: "Réinitialiser le filtre",
    selectAll: "Tout sélectionner",
    deselectAll: "Désélectionner",
    downloadSelection: "Selectie downloaden",
    preview: "Aperçu",
    vouchers: "Vers l'aperçu des points",
    exchangeVoucher: "Utiliser le code du bon d'achat",
    confirm: "CONFIRMER",
    toFavorites: "Vers vos produits préférés",
  },
  myAccount: "Votre compte",
  menu: {
    account: "Mon compte",
    plus: 'À propos de Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Soutien à la vente",
    mailbox: "Boîte postale",
    about: "À propos de BS Plus",
    trainingAndCourses: "Formations et cours",
    externalTraining: "Formations externes",
    productInfo: "Informations sur les produits",
    productBrochures: "Brochures sur les produits",
    priceLists: "Listes de prix",
    price: "Pricat",
    complaintForm: "Formulaire de réclamation",
    sales_support: "Soutien à la vente",
    contact_service: "Contact & Service",
    logOut: "Se déconnecter",
    news: "Actualités",
  },
  productInfo: {
    categories: {
      info: "Infos sur les produits",
      priceList: "Listes de prix",
      contact: "Contact",
    },
    page: {
      description:
        "Bienvenue dans la zone d'information sur les produits Bridgestone & Firestone.<br/>Vous trouverez ici les brochures et listes de prix actuelles ainsi que des liens et des formulaires utiles.",
    },
    index: {
      title: "Informations sur les produits",
      description:
        "Bienvenue dans la zone d'information consacrée aux produits Bridgestone et Firestone.<br/>Vous trouverez ici les brochures actuelles et des documents complémentaires.",
      categories: {
        productBrochures: {
          title: "Brochures sur les produits",
          description:
            "Brochures produits Bridgestone et Firestone actuelles à télécharger",
        },
        bDrive: {
          title: "Images de pneus &<br/>Logos",
          description:
            "Logos, images de produits et modèles de marketing actuels",
          button: "VERS B-DRIVE",
        },
        calculator: {
          title:
            "<span class='text-danger'>Calculateur</span> d'économies de carburant",
          description:
            "Pneus à résistance au roulement optimisée - Calculer facilement les économies potentielles !",
        },
        carApprovals: {
          title: "Homologations pour voitures",
          description:
            "Trouvez les pneus Bridgestone pour voitures adaptés avec homologation",
        },
        motorcycleApprovals: {
          title: "Homologations pour motos",
          description:
            "Trouvez les pneus Bridgestone pour motos adaptés avec homologation",
        },
        dataGenerator: {
          title: "Générateur de fiches techniques",
          description:
            "Saisissez l'IPC et générez votre propre fiche technique",
        },
      },
    },
  },
  productList: {
    pkw: {
      title: "Listes de prix des pneus pour voitures, 4x4 et camionnettes",
      description:
        "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul> <li>Voitures de tourisme, 4x4 et camionnettes</li> </ul>",
    },
    trucksAndBuses: {
      title: "Listes de prix camions et bus",
      description:
        "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul> <li>Camions et bus</li> </ul>",
    },
    motorcycles: {
      title: "Listes de prix pneus moto",
      description:
        "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone : <ul> <li>Moto</li> </ul>",
    },
    agriculture: {
      title: "Listes de prix pneus agricoles",
      description:
        "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul> <li>Agriculture</li> </ul>",
    },
    constructionMachineryOtr: {
      title: "Listes de prix pneus pour machines de chantier/OTR",
      description:
        "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul><li>Machines de chantier/OTR</li></ul>",
    },
    main: {
      title: "Listes de prix",
      description:
        "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul><li>Voitures de tourisme, 4x4 et camionnettes</li><li>Moto</li><li>Camions et bus</li> <li>Agriculture</li><li>Machines de chantier / OTR</li></ul>",
    },
    index: {
      description:
        "Bienvenue dans la zone d'informations sur les produits Bridgestone et Firestone. Vous trouverez ici les brochures actuelles, les tarifs et les dossiers Pricat.",
    },
  },
  productBrochures: {
    desc: "Téléchargez ici les brochures et dépliants actuels sur nos pneus Bridgestone et Firestone pour voitures particulières, SUV et camionnettes.",
    technologiesTitle: "Technologies, marquages et plus encore",
    technologiesDesc:
      "Téléchargez ici les brochures et dépliants actuels sur nos technologies, marquages et autres pour les voitures particulières, les SUV et les camionnettes.",
    BDriveTitle: "Images de pneus & logos",
    BDriveDesc:
      "Vous trouverez ici des images de profil, des logos et bien plus encore à télécharger pour toutes les gammes de produits et toutes les marques.",
    BDriveLinkText: "Lien vers le portail FORMATIONS PNEUMATIQUES & LOGOS",
  },
  contact: {
    index: {
      title: "Contact & Service",
      description:
        "Bienvenue dans la zone de service de BRIDGESTONE PLUS. Vous trouverez ici les coordonnées de l'équipe de service ainsi que la possibilité de soumettre des réclamations concernant les produits via un formulaire.",
    },
    categories: {
      service: {
        description: "Numéro de service pour votre région et contact e-mail",
      },
      form: {
        description:
          "Soumettre une réclamation concernant un produit directement ici via le formulaire",
      },
      touch: {
        title: "Contact Touch Incentive",
        description:
          "Si vous avez des questions sur les produits de la boutique de cadeaux Bridgestone plus, les commandes passées, les délais de livraison et/ou les livraisons. Veuillez contacter le fournisseur externe de la boutique de cadeaux : Touch Incentive Rotterdam : 010 2043075 ou support&#64;touchincentive.com.",
      },
    },
    form: {
      intermediaryAddress: "Adresse de l'intermédiaire",
      nameFirma: "Nom / Société",
      strHouseNr: "Rue & numéro",
      contactPerson: "Personne de contact",
      vehicleDetails: "Informations sur le véhicule",
      vehicleTyres: "Véhicule/pneus*",
      brandNew: "Marchandise neuve (non montée)",
      newItem: "Marchandise neuve (montée)",
      fwd: "Traction avant",
      rwd: "Traction arrière",
      awd: "Quatre roues motrices",
      vehicleManufacturer: "Constructeur de véhicules",
      vehicleModelType:
        "Modèle de véhicule et désignation du type selon l'immatriculation",
      firstRegistration: "Première immatriculation (jj.mm.aaaa)",
      enginePower: "Puissance du moteur (KW par ex. 150)",
      originalEquipment: "Equipement d'origine",
      tireMilageHours: "Kilométrage des pneus (km) / heures de service",
      tireMilage: "Kilométrage des pneus (km)",
      tireHours: "Heures de fonctionnement",
      milageOrHours: "Km ou heures (par ex. 2000)",
      copyTire1: "Copier le pneu 1",
      copyTire3: "Copier le pneu 3",
      damageDetails: "Détails des dommages",
      complaintReason: "Motif de la réclamation*",
      vibration: "Vibration",
      notBalancable: "Non équilibrable",
      sounds: "Bruits",
      airPressureLost: "Perte de pression d'air",
      worn: "Image d'usure",
      runningPerformance: "Kilométrage",
      deformation: "Bosses / déformations",
      profileBreakouts: "Eclatement du profil",
      cracks: "Fissures",
      drivingBehavior: "Comportement de conduite",
      pull: "Tirer",
      wetGrip: "Adhérence sur le mouillé",
      defective:
        'Marchandise neuve défectueuse (veuillez indiquer le n° du bon de livraison sous "Motif de la réclamation texte")',
      otherReason:
        'Autre raison (veuillez indiquer sous "Motif de la réclamation texte")',
      isTyreReplaced: "Les pneus ont-ils déjà été remplacés ?",
      ifYesTyre: "Si oui, marque de la roue de secours",
      clerkName: "Nom de l'agent*",
      conclusion: "Conclusion",
      conclusionContent:
        "<p>Ces informations sont complètes et ont été fournies de bonne foi.<br/>Il est assuré que les pneus faisant l'objet de la réclamation ont été montés sur le véhicule susmentionné<br/>. <br /><br /><b>Les pneus peuvent être coupés à des fins de contrôle. </b><br /><br /><b>En cas d'acceptation de la réclamation, nous nous réservons le droit de rembourser le pneu<br/>après avoir établi un avoir au prorata de sa valeur, ou de compenser par<br/>une livraison de remplacement gratuite.<br/></b><br /> Le pneu accepté sera mis à la ferraille. En cas de refus, ce<br/>peut être réclamé. <br /><br />L'enregistrement des données personnelles susmentionnées est autorisé.<br/></p>",
      agreementReadAccept: "Accord lu et accepté*.",
      termsConditionsRead: "Lire les conditions générales.",
      termsConditionsReadAccept: "CGV lues et acceptées*.",
      send: "Envoyer",
      requiredField: "*Champ obligatoire",
      tires: "Pneus",
      tirePosition: "Position des pneus",
      notKnown: "Pas connu",
      carSUVTractor: "VOITURE/SUV/TRACTEUR",
      CSTFrontLeft: "P/S/T-avant gauche",
      CSTFrontRight: "P/S/T-avant droite",
      CSTRearLeft: "P/S/T-arrière gauche",
      CSTRearRight: "P/S/T-arrière droite",
      motorcycle: "MOTO",
      motFront: "MOT-avant",
      motRear: "MOT-arrière",
      truck: "CAMION SZM",
      truckSteeringAxle1Left: "Essieu directeur du camion 1 gauche",
      truckSteeringAxle1Right: "Essieu directeur de camion 1 droite",
      truckSteeringAxle2Left: "Essieu directeur de camion 2 gauche",
      truckSteeringAxle2Right: "Essieu directeur de camion 2 droite",
      truckDriveAxle1LeftInner: "Essieu moteur de camion 1 intérieur gauche",
      truckDriveAxle1LeftOuter: "Essieu moteur du camion 1 extérieur gauche",
      truckDriveAxle1RightInner: "Essieu moteur de camion 1 intérieur droit",
      truckDriveAxle1RightOuter: "Essieu moteur de camion 1 extérieur droit",
      truckDriveAxle2LeftInner: "Essieu moteur de camion 2 extérieur gauche",
      truckDriveAxle2LeftOuter: "Essieu moteur de camion 2 intérieur gauche",
      truckDriveAxle2RightInner: "Essieu moteur de camion 2 extérieur droit",
      truckDriveAxle2RightOuter: "Essieu moteur de camion 2 intérieur droit",
      truckTrailingAxleLeft: "Essieu suiveur pour camion, gauche",
      truckTrailingAxleRight: "Essieu suiveur pour camion, droit",
      trailerSemi: "REMORQUE/SEMI-REMORQUE",
      trailerAxle1LeftOuter: "Axe TRAILER 1 extérieur gauche",
      trailerAxle1LeftInner: "Axe TRAILER 1 intérieur gauche",
      trailerAxle1RightOuter: "Axe TRAILER 1 extérieur droit",
      trailerAxle1RightInner: "Axe TRAILER 1 intérieur droit",
      trailerAxle2LeftOuter: "Axe TRAILER 2 extérieur gauche",
      trailerAxle2LeftInner: "Axe TRAILER 2 intérieur gauche",
      trailerAxle2RightOuter: "Axe TRAILER 2 extérieur droit",
      trailerAxle2RightInner: "Axe TRAILER 2 intérieur droit",
      trailerAxle3LeftOuter: "Axe TRAILER 3 extérieur gauche",
      trailerAxle3LeftInner: "Axe TRAILER 3 intérieur gauche",
      trailerAxle3RightOuter: "Axe TRAILER 3 extérieur droit",
      trailerAxle3RightInner: "Axe TRAILER 3 intérieur droit",
      DOT: "DOT (veuillez indiquer TOUS les 10-11 chiffres)",
      TruckSerialNo: "N° de série (uniquement pour les pneus de camion)",
      complaintReasonText: "Motif de la réclamation Texte",
      csNumberIfNeed: "Numéro de client (si disponible)",
    },
    teams: {
      tyre: "Commerce de pneus d'équipe",
      car: "Concessionnaire automobile d'équipe",
    },
    carDealers: {
      title: "Votre interlocuteur personnel chez Bridgestone",
    },
  },
  mainPage: {
    categories: {
      productInfo: "Informations sur les produits",
      salesSupport: "Soutien à la vente",
    },
  },
  fireStoneProducts: {
    title: "Produits Firestone",
    description:
      "Téléchargez ici les brochures et dépliants actuels sur nos pneus Firestone pour voitures particulières, SUV et camionnettes.",
    files: {
      summer: {
        title: "VANHAWK MULTISAISON",
        description: "Transporteur - Toutes saisons",
        date: "Aperçu des produits 2021",
      },
      winter: {
        title: "WINTERHAWK 4",
        description: "Voiture, SUV - Hiver",
        date: "Aperçu des produits 2020",
      },
    },
  },
  complaintForm: {
    title: "Formulaire de réclamation",
    description:
      "Remplissez le formulaire ci-dessous pour toute réclamation concernant nos pneus :",
    sections: {
      damageType: {
        title: "type de dommage",
      },
      generally: {
        title: "général",
      },
      regulator: {
        title: "Adresse distributeur de pneus - régulateur",
      },
    },
    fields: {
      ordinance: "Clé de classification du commerçant",
      pickupLocation: "Lieu de collecte",
      ifAvailable: "(si disponible)",
      companyName: "Nom (entreprise)",
    },
  },
  salesPromotions: {
    title: "Promotion des ventes",
    desc: "Avec nos actions de promotion des ventes pour Bridgestone et Firestone, nous vous soutenons activement dans votre entretien de vente et vous donnons des arguments supplémentaires. Si vous souhaitez profiter de ces actions pour votre entreprise, vous pouvez vous informer sur cette page et demander votre participation en tant que partenaire commercial.",
    bonusCampaign: {
      title:
        '<span class="font-sm">Promotion de primes Bridgestone</span><br/><h3 class="fw-bold">CONDUIRE <span class="text-danger">NOS MEILLEURS</span></h3>',
      desc: "Dans le cadre de l'action DRIVE OUR BEST, les clients qui achètent au moins 2 pneus premium Bridgestone dans les commerces participants reçoivent un bon d'achat d'une valeur allant jusqu'à 40 CHF, à utiliser chez des partenaires attractifs comme Amazon, Aral/OMV, Media Markt, REWE, Shell, Zalando et bien d'autres. <br/><br/>Le montant du bon d'achat dépend du nombre de pneus achetés et de leur taille en pouces.",
    },
    guarantee: {
      title:
        '<span class="font-sm">Garantie des pneus Bridgestone</span><br/><h3 class="fw-bold">PNEU <span class="text-danger">PROTECTION</span></h3>',
      desc: "Dommages dus à l'enfoncement et aux bordures de trottoir - ce qui était jusqu'à présent synonyme de frustration et d'agacement, Bridgestone le résout avec succès depuis 2020 de manière numérique, conviviale pour le revendeur et le client, grâce à une garantie de deux ans sur les pneus.<br/><br/>En fonction de l'âge de son pneu Bridgestone couvert, votre client reçoit en cas de dommage jusqu'à 100% du prix d'achat du pneu de remplacement.<br/><br/>Nouveau depuis 2023 : Vos clients peuvent bénéficier de la garantie dès l'achat de 2 pneus de toutes les tailles de pouces.",
    },
    premium: {
      title:
        '<span class="font-sm">Prime &amp; garantie Firestone</span><br/><h3 class="fw-bold">ACTION <span class="text-danger">AVANTAGEUSE</span></h3>',
      desc: "En participant à l'ACTION AVANTAGE FIRESTONE, les acheteurs d'au moins 2 pneus Firestone bénéficient non seulement d'une garantie de 24 mois sur les pneus, qui couvre par exemple les dommages causés par les trottoirs ou l'enfoncement, mais aussi d'un bon d'achat de BestChoice d'une valeur pouvant atteindre 20 CHF.<br/><br/>Nouveau depuis 2023 : La participation est possible dès l'achat de 2 pneus de voiture, de SUV ou de camionnette de toutes les dimensions en pouces.",
    },
    participation: {
      title: "Demander à participer maintenant",
      desc: "Vous souhaitez mettre en place une ou plusieurs de nos actions dans votre magasin ? Dans ce cas, vous pouvez demander votre participation ici. Votre entreprise sera activée pour la ou les actions et vous recevrez du matériel d'action pour votre espace de vente dans un délai de 4 semaines. <br/><br/>Faites votre choix :",
      success: "Merci beaucoup, votre demande a été envoyée",
      bonusCampaign:
        '<span class="fw-bold">DRIVE <span class="text-danger">OUR BEST</span> - La promotion de primes Bridgestone',
      guarantee:
        '<span class="fw-bold">TYRE <span class="text-danger">PROTECT</span></span> - Garantie des pneus Bridgestone',
      advantage:
        '<span class="fw-bold">ACTION <span class="text-danger">AVANTAGEUSE</span></span> - L\'action de prime Firestone avec une garantie supplémentaire sur les pneus',
      premium:
        '<span class="fw-bold">ACTION <span class="text-danger">AVANTAGEUSE</span></span> - L\'action de prime Firestone avec une garantie supplémentaire sur les pneus',
      request: "Demand de participation",
    },
  },
  trainings: {
    seasons: {
      all: "Toutes les saisons",
      summer: "Été",
      winter: "Hiver",
      general: "Général",
    },
    offer:
      "Nous élargissons régulièrement notre offre <br />pour vous ! <br /><br />Nous vous informons des nouvelles formations <br />dans votre boîte aux lettres.",
    summary: {
      congratulations: "FÉLICITATIONS - VOUS AVEZ APPORTÉ VOTRE EXPERTISE À",
      participation: "Vous avez participé avec succès au {Name}.",
      certificate:
        "Vous recevrez votre certificat par e-mail ou vous pouvez également le télécharger directement ici au format PDF :",
      send: "Télécharger le certificat",
    },
    online: {
      title: "Nos formations en ligne",
      desc: "Obtenez des connaissances d'experts et, en cas de réussite aux tests de formation, votre certificat de participation personnel<br> ainsi que 40 points supplémentaires pour le club de primes.",
      short_desc:
        "Obtenez des connaissances d'experts et, en cas de réussite aux tests de formation, votre certificat de participation personnel<br> ainsi que 40 points supplémentaires pour le club de primes.",
      content:
        "Découvrez dès maintenant nos formations en ligne actuelles et participez immédiatement ici sur la plateforme :",
    },
    lectures: {
      title: "Formation Bridgestone",
      desc: "Développez vos connaissances d'expert et inscrivez-vous à nos formations et stages intensifs pour vous et votre équipe. Vous avez la possibilité de participer aux formations au centre de compétence et de formation Bridgestone de Dietzenbach (près de Francfort-sur-le-Main) ou, pour certaines formations, de les faire réaliser dans votre entreprise. Vous pouvez utiliser vos points de récompense pour les formations et ainsi compenser tout ou partie des coûts avec vos points.",
      content:
        "Découvrez maintenant nos formations actuelles et demandez une réservation :",
    },
    singleLecture: {
      registerForm: {
        title: "Contenu de la formation",
        inquiry: "Demande",
        interested: "Je suis intéressé(e) par la formation",
        participantsNr: "Nombre de participants",
        pointsFromBalance:
          "Je souhaite utiliser des points de mon crédit de points.",
        reduction: "Cela correspond à une réduction des coûts de {points} CHF.",
        request: "Envoyer une demande",
      },
      success: {
        thanks: "Merci beaucoup",
        title: "Votre demande a été envoyée à l'équipe de formation.",
        feedbackTime:
          "Vous recevrez une réponse dans les 14 jours pour clarifier tous les détails<br />.",
        points:
          "Les points de prime utilisés, soit<br /> {points}, ont été déduits de votre compte de points<br />.",
        refund:
          "Si la formation n'a pas lieu, les points<br />vous seront bien entendu recrédités.",
        queries: "Pour toute question, veuillez vous adresser à",
      },
      index: {
        costs: "Coûts et informations sur la participation",
        duration: "Durée : {duration}",
        cost: "Coût {cost} : {price} CHF ({points} points)",
        participantsNr:
          "Nombre de participants : min. {min} -max. {max} personnes",
      },
    },
    index: {
      title: "Formations et cours",
      desc: "Une longueur d'avance grâce au savoir : assurez-vous de disposer d'un savoir-faire exclusif pour vous et votre équipe grâce à nos offres de formation. Que ce soit avec nos formations en ligne, auxquelles vous pouvez participer directement sur la plateforme, avec nos formations et séminaires pratiques au centre de formation Bridgestone ou encore avec des formations externes dont vous pouvez réduire les coûts avec vos points de récompense.",
      online: {
        title: "Formations en ligne",
        desc: "Découvrez la formation en ligne et obtenez un aperçu du monde des produits Bridgestone!",
        short_desc:
          "Découvrez la formation en ligne et obtenez un aperçu du monde des produits Bridgestone !",
      },
      lectures: {
        title: "Formations",
        desc: "Des offres de formation de qualité dans notre centre de formation ou dans vos locaux.",
      },
      external: {
        title: "Formations externes",
        desc: "Utiliser des points de récompense pour des offres de tiers et réduire les coûts.",
      },
    },
  },
  salesSupport: {
    title: "Soutien à la vente",
    desc: "Nous vous proposons différentes mesures et actions pour soutenir activement vos ventes - de l'action de promotion des ventes à forte impulsion au soutien individuel en passant par un espace de vente attrayant.",
    salesPromotions: {
      title: "Promotion des ventes",
      desc: "Des cadeaux et des garanties attrayants pour vos clients lors de l'achat de pneus.",
    },
    displaysFurniture: {
      title: "Présentoirs & meubles",
      desc: "Utilisez vos points de récompense pour obtenir des équipements de qualité pour votre espace de vente.",
    },
    individualSupport: {
      title: "Support individuel",
      desc: "Assurer un soutien individuel grâce à vos points de récompense.",
    },
  },
  serviceNumber: {
    title: "Interlocuteurs et numéros de service",
    subtitle: "Vos interlocuteurs personnels chez Bridgestone",
    description:
      "Nous sommes toujours là pour vous ! Trouvez ici votre interlocuteur Bridgestone personnel<br/>pour votre région ou adressez-vous tout simplement à nos collaboratrices et collaborateurs compétents<br/>du service clientèle.",
    manager: "Directeur des ventes Allemagne",
    yourCustomerService: "Votre service client",
    generalCustomerService: "Service clientèle en général",
    salesTerritory: "Zone de vente",
    carDealer: "Concessionnaire automobile",
    centralEmail: "Contact e-mail central",
    sales_manager: "Directeur des ventes Pays-Bas",
    contact_person: "Bridgestone plus personne de contact",
    sales_representative: "Représentant des ventes",
    key_account: "Responsable grands comptes",
    warranty: "Garantie",
    car_releases: "Homologations pour voitures particulière",
    motorcycle_releases: "Homologation des motos",
    commercial_vt: "Commerce électronique",
    agricultural_tires: "Pneus agricoles",
  },
  directions: {
    west: "Ouest",
    north: "Nord",
    east: "Est",
    south: "Sud",
  },
  training: {
    title: "Certificat et {points} points supplémentaires pour vous !",
    subtitle:
      "Assurez-vous de recevoir votre certificat de participation personnel et en plus {points} de points supplémentaires pour le club de primes.",
    description:
      "Et comment faire ? C'est très simple : terminez avec succès le test d'entraînement après la vidéo ! Le test apparaît dès que vous avez regardé la vidéo en entier !",
  },
  about: {
    title: "À propos de Bridgestone <span class='text-danger'>Plus</span>",
    description:
      "VOTRE <span class='text-danger'>PLUS</span> AVEC BRIDGESTONE - c'est notre motif directeur pour l'ensemble du programme BRIDGESTONE <span class='text-danger'>PLUS</span><br/>destiné à nos partenaires commerciaux. Découvrez les nombreux avantages exclusifs.",
    sections: {
      first: {
        title: "Des produits récompensés dans le segment premium et qualité",
      },
      second: {
        title: "Programme de primes attractif",
      },
      third: {
        title: "Un soutien efficace des ventes",
        description:
          "Des possibilités étendues pour des expériences d'achat exclusives et votre présence digitale sur des points de contact pertinents.",
        subtitle: "Nos actions de promotion des ventes éprouvées",
        pointInfo:
          "Profitez d'arguments de vente supplémentaires et vos clients d'actions de primes et de valeur ajoutée passionnantes.",
        numberInfo:
          "Traitement digitale direct avec votre client - pas de travail supplémentaire pour vous !",
        subtitle2: "Une présence forte avec notre équipement d'espace de vente",
        description2:
          "Mettez en scène votre espace de vente de manière attrayante et offrez à vos clients un séjour agréable grâce à nos modules pour les zones de comptoir, les surfaces d'exposition, les zones d'attente et les espaces extérieurs ainsi que les solutions digitale!",
        description3:
          "Collectionnez des points et <b>faites la promotion de votre entreprise</b> avec nous",
      },
      fourth: {
        title: "TOUT SUR UNE SEULE PLATEFORME : LE PORTAL BRIDGESTONE PLUS",
        description:
          "Avec votre accès personnel au portail en ligne, vous avez un accès direct à l'offre variée<br>de BRIDGESTONE <span class='text-danger'>PLUS</span>.",
        list: {
          program: "Programme de points",
          shop: "Boutique des primes",
          priceList: "Listes de prix",
          productInfo: "Informations sur les produits",
          salePromotion: "Soutien à la vente",
          onlineTrainings: "Formations en ligne",
          andMore: "et bien d'autres choses encore.",
        },
        title2: "Formations régulières en ligne",
        description2:
          "Restez à jour et profitez avec votre équipe des formations en ligne de Bridgestone.",
      },
      points: {
        title:
          "Formations en ligne actuelles dans les domaines des produits et de la vente :",
        list: {
          one: "Formation à la vente",
          two: "Constructions de pneus",
          three: "Reconnaître les images de dommages",
        },
        subtitle: "VOTRE participation sera récompensée",
        description:
          "Vous recevez <b>40 points</b> et un <b>certificat de participation</b> pour chaque formation en ligne terminée !",
      },
    },
    fullPremium:
      "L'ensemble de la gamme Bridgestone PKW Premium pour le marché du remplacement a été <strong>systématiquement classé \"A\"</strong> pour l'<strong>adhérence sur sol mouillé.</strong>",
  },
  her: "Votre",
  seasons: {
    summer: "Été",
    winter: "Hiver",
    all: "Toutes les saisons",
  },
  loginPage: {
    title: "S'inscrire",
    resetTitle:
      'Bienvenue chez BRIDGESTONE <span class="text-danger">PLUS</span>',
    desc1:
      'Vous vous êtes déjà inscrit avec succès sur le portail BRIDGESTONE <span class="text-danger">PLUS</span>.',
    desc2:
      "Ensuite, connectez-vous avec votre adresse e-mail et votre mot de passe.",
    desc3:
      "Connectez-vous à l'aide de votre adresse e-mail et de votre mot de passe.",
    resetSubTitle:
      'Vous êtes un participant au Bridgestone <span class="text-danger">TYRECLUB</span>?',
    resetDesc:
      "Ensuite, commencez par définir votre nouveau mot de passe pour l'adresse e-mail que vous avez utilisée pour le <span class='text-danger'>TYRECLUB</span> via la fonction <b>Mot de passe oublié</b>.",
    footer: "Vous serez ensuite automatiquement connecté.",
    resetNewPass: "DÉFINIR UN NOUVEAU MOT DE PASSE",
    noAccount: "Je n'ai pas encore de compte",
    error: "Données de connexion incorrectes, veuillez réessayer !",
    logWithAzure: "Connectez-vous avec Azure",
  },
  maintenance: {
    title: "Travaux de maintenance !",
    desc: "Des travaux de maintenance nécessaires ont actuellement lieu sur les serveurs.<br/><br/>Par conséquent, l'accès à <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b> n'est actuellement pas disponible pour vous.<br/><br/>Nous vous remercions de votre patience et vous remercions de votre compréhension.<br/><br/> Votre équipe Bridgestone",
  },
  contactPage: {
    title: "Formulaire de réclamation",
    description:
      "Remplissez le formulaire ci-dessous pour toute réclamation concernant nos pneus :",
    damage: "Dommages matériels",
    personalInjury: "Dommages corporels",
  },
  yesText: "oui",
  noText: "non",
  wrongFileError: "Le format de fichier requis est le PDF",
  toastMessages: {
    addProduct: "Votre produit a été ajouté au panier.",
    addProducts: "Vos produits ont été ajoutés au panier.",
    profileSaved: "Les données de votre profil ont été enregistrées",
    canAddProduct: "Tu n'as pas assez de points.",
    customerNumberSaved: "Numéro de client enregistré",
    customerNumberExist: "Numéro de client disponible",
    complaintForm:
      "Votre demande a été acceptée. Veuillez attendre une réponse",
    openHourSaved: "Les heures d'ouverture ont été enregistrées",
    changeParentId:
      "Vous ne pouvez pas modifier la branche avec le numéro de client supérieur si elle a des branches subordonnées.",
    requestSent: "La demande a été envoyée",
    completeProfileRequired:
      "Vous devez remplir votre profil à 100 % pour pouvoir poursuivre vos achats dans la boutique.",
    accessDenied: "Accès refusé",
    incomplete_address: "L'adresse est incomplète. Vérifiez s'il vous plaît",
    waitMoment: "Attendez un moment",
    favoriteAdded: "Ajouté aux favoris.",
    favoriteRemoved: "Retiré des favoris.",
    downloadFinished: "Téléchargement terminé",
    selectOneField: "Sélectionnez un champ",
    noVoucher: "Le bon n'a pas été trouvé",
  },
  order: {
    number: "Référence de commande",
    createdDate: "Commandé le",
    description:
      "Vous trouverez ici un aperçu de vos commandes de la boutique de primes.",
    success:
      "Merci beaucoup ! Votre commande a été validée. Vous recevrez dans quelques minutes une confirmation de commande dans votre boîte aux lettres.",
    anyOrder: "Aucune commande",
    shippedAt: "Envoyé à",
    sku: "SKU",
    status: {
      created: "Créé",
      confirm_order: "Confirmer la commande",
      ready_for_shipment: "Prêt à être envoyé",
      rejected: "Refusé",
      processed: "Traite",
      shipped: "Envoyé",
      returned: "Est revenu",
      finished: "terminé",
    },
    details: {
      title: "Détails de la commande",
      description: "Vérification et gestion des nouveaux contrats",
    },
    date: "Date de commande",
    products: "Produits",
    quantity_short: "pcs",
  },
  orders: "Commandes",
  hunter: {
    title: "Hunter",
    description:
      "Des machines et des équipements de haute qualité pour votre atelier sont un investissement dans le succès de votre entreprise. Utilisez vos points de récompense BRIDGESTONE <span class='text-danger'>PLUS</span> pour bénéficier d'une réduction sur l'achat de machines d'atelier HUNTER. Les points de prime que vous utilisez sont directement facturés à HUNTER et se répercutent ainsi sur le prix d'achat.",
    priceInfo: "Prix net, fret et mise en service/instruction compris",
    pointsInfo: "Prix net en points",
    investInfo:
      "Possibilité de déduire ou de comptabiliser les points via une aide à l'investissement.",
    contactInfo:
      "Si vous avez des questions sur la procédure à suivre, veuillez nous contacter personnellement. Contact",
    specification: "Spécifications",
    pointDiscount: "Cela correspond à {price} CHF",
    form: {
      title: "Je suis intéressé(e) par",
      subtitle: "Je souhaite utiliser des points de mon crédit de points",
      description:
        "Une fois votre demande effectuée, nous prendrons contact avec vous. Nous restons bien entendu à votre disposition pour répondre à vos questions.",
    },
  },
  intro: {
    step1: {
      title: "RELATIF AUX PERSONNES",
      description:
        "Vous trouverez ici des informations sur votre compte Plus et votre boîte aux lettres Plus.",
    },
    step2: {
      title: "APERÇU DES POINTS",
      description:
        "Vous trouverez ici votre aperçu des points. Vous pouvez consulter vos performances des douze derniers mois et vous assurer des primes avec des points.",
    },
    step3: {
      title: "SE TENIR AU COURANT",
      description:
        "Faites-vous expliquer les fonctions de Bridgestone Plus et découvrez tout ce qu'il est encore possible de faire.",
    },
  },
  wholesaler: {
    dashboard: {
      title: "{name} Tableau de bord",
      extraTitle: "WHOLESALER DASHBOARD",
      description:
        "Bienvenue sur votre tableau de bord. Vous pouvez y consulter les chiffres clés actuels et les entreprises participantes de votre clientèle.",
      overview: {
        title: "Aperçu des clients participants",
        description:
          "Entreprises qui se sont inscrites à BRIDGESTONE PLUS et que nous pouvons attribuer à vos entreprises grâce à leur numéro de client.",
        month: "Nouveau ce mois-ci",
        year: "Nouveau cette année",
        all: "Total",
      },
      credits: {
        title: "Crédits de points {name}",
        description:
          "Points de récompense attribués aux entreprises participantes sur la base des chiffres de vente que vous avez téléchargés. Dans cette vue, les points réguliers sont affichés sans les promotions.",
        month: "Dernier mois",
        year: "Année en cours",
        prev_year: "Total",
        prev_month: "le mois précédent",
        allDealers: "Tous les points des commerçants",
      },
      details: {
        title: "Détail des clients participants",
        description:
          'Vous trouverez ci-dessous les entreprises qui se sont enregistrées sur BRIDGESTONE <span class="text-danger">PLUS</span> avec un {name} numéro de client et qui vous ont été attribuées en tant que responsable. Utilisez simplement les fonctions de tri pour obtenir une autre séquence de pneus ou le masque de recherche.',
      },
      lastImport:
        'Dernière importation des chiffres de vente : <br/> <span class="text-danger">{date}</span>',
      loadMore: "Chargement de 20 autres commerçants",
      tyres: {
        title: "Pneus",
        description: "Pneus achetés par les participants au programme",
      },
      reload: "Recharger",
    },
  },
  staff: {
    dashboard: {
      title: "Tableau de bord du service extérieur",
      description:
        "Bienvenue sur votre tableau de bord. Vous pouvez y consulter les chiffres clés actuels et les entreprises participantes de votre clientèle.",
      overview: {
        title: "Aperçu des clients participants",
        description:
          'Les entreprises qui se sont inscrites à BRIDGESTONE <span class="text-danger">PLUS</span> et que nous pouvons vous attribuer grâce à leur numéro de client.',
        month: "Nouveau ce mois-ci",
        year: "Nouveau cette année",
        all: "Total",
      },
      credits: {
        title: "Crédits de points",
        description:
          "Points de récompense attribués aux entreprises participantes sur la base des chiffres de vente communiqués.",
        month: "Dernier mois",
        year: "Année en cours",
        prev_year: "Total",
        prev_month: "le mois précédent",
        allDealers: "Tous les points des commerçants",
        allPoints: "Tous les points",
      },
      details: {
        title: "Détail des clients participants",
        description:
          'Vous trouverez ci-dessous la liste des entreprises qui se sont enregistrées sur BRIDGESTONE <span class="text-danger">PLUS</span> avec un numéro de client Bridgestone et qui vous ont été attribuées en tant que responsable. Utilisez simplement les fonctions de tri pour obtenir une autre séquence de pneus ou le masque de recherche.<br/><br/> <b>Remarque :</b> si vous cliquez sur le solde de points, vous accédez à l\'extrait de compte détaillé',
      },
      lastImport:
        'Dernière importation des chiffres de vente : <br/> <span class="text-danger">{date}</span>',
      kickback: {
        description:
          "Les entreprises participantes sont créditées de frais de kickback sur la base des chiffres d'affaires transmis.",
      },
      tyres: {
        title: "Pneus",
        description: "Pneus achetés par les participants au programme",
      },
      reload: "Recharger",
      exports: {
        title: "Excels Exportés",
        head: {
          name: "Nom",
          status: "Statut",
        },
      },
    },
  },
  newsFeed: {
    more: "Plus d'informations sur",
  },
  investment: {
    title: "Soutien aux investissements",
    description:
      "Bridgestone vous soutient également individuellement dans vos investissements d'entreprise. Qu'il s'agisse de l'achat de machines ou d'équipements d'atelier, de véhicules de remplacement pour l'atelier ou d'activités de marketing comme la diffusion d'annonces ou de bannières en ligne, etc. - utilisez vos points BRIDGESTONE PLUS pour refinancer vos investissements. Il vous suffit, une fois l'investissement réalisé, d'envoyer ici la facture du prestataire concerné et d'indiquer le nombre de points de prime que vous souhaitez utiliser ici. Suivez les instructions ci-dessous.",
    description_old:
      "Aide à l'investissement pour l'équipement d'atelier subvention de promotion pour les projets de marketing",
    info: {
      paragraph2_old:
        "Mettez à jour votre équipement d'atelier ou votre espace de vente ou faites de la publicité pour mieux commercialiser vos produits. Pour ce faire, veuillez nous indiquer la valeur en points que vous souhaitez consacrer à cette prime. La valeur minimale des points est de 1.250 points.Valeur par point = 0,25 CHF",
      paragraph2:
        "Vous réalisez l'investissement souhaité et équilibrez la facture du tiers.",
      paragraph3_old:
        "Pour le décompte de la prime, nous avons besoin de votre facture correspondant au montant des points récupérés (nombre de points x 0,25 CHF = montant net de la facture) et d'une copie de la facture originale. Vous trouverez un modèle de facture",
      paragraph3:
        "Pour terminer, faites une demande de subvention sur cette page dans le champ de demande à droite.",
      paragraph4_old:
        "Nous vous prions à cet effet de nous contacter personnellement afin d'entamer les démarches ultérieures.",
    },
    excludeText:
      "Nous vous prions de comprendre que les investissements dans les offres de la concurrence directe sont exclus.",
    here: "ici",
    contactPerson: "Personne de contact",
    email: "Email",
    phone: "Tél",
    payInfo: "Le paiement peut prendre jusqu'à 8 semaines !",
  },
  notice: "Remarque",
  noticeDescription:
    "En cas de dommages matériels et/ou corporels, veuillez vous adresser directement à Bridgestone CHF NV/SA Succursale Allemagne Tél. : 0049-6172-408-435, E-mail : <a href='mailto:{email}'>{email}</a>, car ils font l'objet d'un traitement séparé.",
  yourEmail: "Votre adresse e-mail",
  addressEndCustomer: "Adresse du client final",
  tireSizeExample: "Taille des pneus (par ex. 215/60/16)",
  profileDesignation:
    "Désignation du profil, y compris la spécification (par exemple : RE050A, R168 Eco, ...)",
  speedLoadIndex: "Indice de vitesse / de charge",
  restDay: "Jour de repos",
  breakTimes: "Temps de pause",
  claimFrom: {
    pdf: {
      number: "N° de formulaire",
      tireSizeExample: "Taille des pneus",
      dot: "DOT",
      vehicleModelType: "Modèle/type de véhicule",
      enginePower: "Puissance du moteur (KW)",
      speedLoadIndex: "Indice de vitesse",
      profile: "Profil",
      damage: "Dommages",
      replacementStamp: "Timbre de remplacement",
      personalInjury: "Dommages corporels",
      tiresReplaced: "Pneus remplacés",
      agb: "CONDITIONS GÉNÉRALES DE VENTE",
      clerkName: "Nom de la personne en charge du dossier",
      complaintReason: "Motif de la réclamation",
      complaintReasonText: "Motif de la réclamation Texte",
      vehicleTyres: "Véhicule/pneus",
    },
  },
  fuelCalculator: {
    oldLabel: "ANCIEN LABEL DE CARBURANT",
    selectOldLabel: "Choisir la valeur de l'étiquette",
    tyreLife: "Kilométrage total (du train de pneus en KM)",
    tyreLifeLabel: "Saisir le kilométrage total, par ex. 40 000",
    fuelPrice: "Prix de l'essence (par litre en CHF)",
    fuelPriceLabel: "Saisir le prix de l'essence, par ex. 1,82",
    newLabel: "NOUVEAU LABEL POUR LE CARBURANT",
    selectNewLabel: "Choisir la valeur de l'étiquette",
    fuelConsumption:
      "Consommation de carburant (du véhicule aux 100 km en litres)",
    fuelConsumptionLabel:
      "Saisir la consommation de carburant, par exemple 7,8",
    table: {
      euroSave: "Économies sur la durée totale",
      fuelSavePercent: "Changement de la consommation de carburant",
      newConsumption: "Nouvelle consommation de carburant aux 100 km",
      fuelSaveLiter: "La consommation de carburant diminue aux 100 km de",
      fuelSaveTotalLiter: "La consommation de carburant diminue de",
    },
    results: "Résultats et économies potentielles",
    please: "veuillez RESPECTER les remarques sous les résultats",
    calcHeader:
      "indiquez ici les données de base concernant les pneus et le véhicule :",
    mainDesc:
      "Avec le <b>calculateur d'économie de carburant</b>, vous pouvez calculer facilement et directement l'économie qu'une meilleure classe de résistance au roulement peut permettre de réaliser sur des pneus neufs par rapport à une classe inférieure. Pour ce faire, il vous suffit de saisir les valeurs dans le formulaire.<br/><br/><b>Le résultat se réfère au kilométrage total et vous offre un argument supplémentaire de poids lors de l'entretien de vente - recommandez les pneus premium de Bridgestone avec une résistance au roulement optimisée !",
    description:
      "Des pneus à faible résistance au roulement, correctement gonflés (selon les spécifications du fabricant), peuvent permettre d'économiser jusqu'à 10 % de carburant. Cela se traduit par des économies financières sur les coûts d'exploitation ou, dans le cas des véhicules électriques par exemple, permet au conducteur de parcourir une distance supplémentaire avant de devoir faire le plein ou de recharger. La classe de résistance au roulement va de A (la plus efficace) à E (la moins efficace). Plus la classe énergétique est élevée, plus la résistance au roulement est faible.",
    noticeText:
      "En se basant sur la base de données de la Commission CHFopéenne, une économie maximale de carburant de 10% a été supposée pour toutes les classes d'étiquettes (étiquette A par rapport à l'étiquette E). Il s'agit d'une valeur maximale qui suppose notamment que l'on utilise les pneus avec les pressions de gonflage optimales indiquées par le fabricant du véhicule ou du pneu (plus d'informations à ce sujet sur le site de la Commission Européenne <a href='https://commission.Europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en'>: https://commission.Europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en)</a>. Sur la base de l'économie maximale de carburant, en supposant une réduction linéaire, on obtient une différence d'environ 2,5% par changement de classe d'étiquette immédiatement supérieure. Ce pourcentage est déduit de la valeur initiale de la consommation d'essence par la logique de facturation. Exemple : la valeur de consommation indiquée est de 7,0 l aux 100 km. Il s'agit de calculer l'économie de carburant réalisée en passant de l'étiquette C à l'étiquette A. En se basant sur la logique ci-dessus, on obtient une économie de 2,5% * 2 = 5%. En tenant compte de la valeur de consommation indiquée, on obtient la nouvelle valeur de consommation suivante : 7,0 l * (100 % - 5 %) = 6,65 l et donc une économie de 0,35 l / 100 km.<br/><br/>Bridgestone souligne expressément qu'il s'agit d'une valeur théorique en ce qui concerne le pourcentage de changement pris en compte ci-dessus, qui reflète la fourchette supérieure des économies de carburant possibles grâce à la résistance au roulement du pneu. Elle n'est donc qu'une approximation et ne peut pas toujours être atteinte dans la pratique, car la consommation de carburant d'un véhicule (et donc son économie) dépend, outre de la résistance au roulement du pneu, de nombreux autres facteurs (par ex : Le style de conduite, la vitesse, la pression des pneus, la température des pneus et la température ambiante, la résistance à l'air du véhicule, la charge du véhicule, les conditions routières ainsi que les réglages du châssis et du véhicule), qui s'influencent également entre eux. Les résultats des calculs effectués ne représentent donc qu'une estimation approximative sans engagement, pour l'exactitude et la précision de laquelle Bridgestone décline toute responsabilité.",
  },
  legalNotice: "Mentions légales",
  addCsNumber: {
    body: "Êtes-vous sûr de vouloir enregistrer ce numéro de client ? Cette action bloque les données d'édition jusqu'à ce que l'administrateur les approuve.",
  },
  priceDescription:
    "Téléchargez les listes de prix actuelles pour votre usage.",
  pricatDescription:
    "Vous pouvez obtenir ici des fichiers Pricat pour votre système de gestion des marchandises.",
  pricat: {
    title: "Pricat",
    description:
      "Téléchargez ici des enregistrements CSV et TEXT pour vos systèmes de gestion des marchandises, systèmes informatiques & Co.",
  },
  fillProfile: "Remplissez le profil pour pouvoir télécharger le certificat,",
  certificate: {
    header: "CERTIFICAT",
    atCourse: "a participé avec succès au cours",
    takePart: "a participé.",
    contains: "ÉLÉMENTS DU COURS",
  },
  afterTraining: {
    congratulations: "Félicitations",
    allAnswer: "Tu as répondu correctement à toutes les questions",
    points: "Vous recevez {points} immédiatement sur votre compte  !",
    clickToProfile: "cliquez sur le lien",
  },
  kickback: {
    title: "Frais de kickback",
    word: "Kick-back",
    description:
      "Les entreprises participantes sont créditées de frais de kickback sur la base des chiffres d'affaires transmis.",
  },
  externalLinks: {
    tyreBuy: "Commander des pneus",
  },
  loginPageSteps: {
    welcome:
      "Bienvenue sur BRIDGESTONE PLUS - le portail à valeur ajoutée de Bridgestone.",
    step1: {
      title: "Nouveau ici ?",
      description:
        "C'est votre première visite sur le portail BRIDGESTONE <span class='text-danger'>PLUS</span>?<br /><br />Alors inscrivez-vous maintenant !",
      actionBtn: "S'INSCRIRE MAINTENANT",
    },
    step2: {
      title: "<span class='text-danger'>TYRECLUB</span> Revendeurs",
      description:
        "Vous avez déjà des données d'accès pour l'ancien <span class='text-danger'>TYRECLUB</span> de Bridgestone ?<br /><br />Alors définissez ici votre nouveau mot de passe pour l'adresse e-mail que vous utilisiez pour le <span class='text-danger'>TYRECLUB</span>.",
      actionBtn: "DÉFINIR UN NOUVEAU MOT DE PASSE",
    },
    step3: {
      title: "Bienvenue chez BRIDGESTONE <span class='text-danger'>PLUS</span>",
      description:
        "Connectez-vous à l'aide de votre adresse e-mail et de votre mot de passe.<br/></br><b>Vous êtes nouveau ici?</b><br/></br>Créez ensuite votre nouveau compte d'utilisateur en utilisant la fonction ENREGISTREMENT.<br/></br>Vous serez alors automatiquement connecté.",
      actionBtn: "S'INSCRIRE",
    },
    info: "As-tu besoin d'aide? Contactez nous s'il vous plait: <a href=\"mailto:{email}\">{email}</a>",
  },
  marketingModal: {
    title: "Conditions générales et conditions de participation",
    description:
      "Après acceptation de la 'lettre d'engagement', vous recevrez une copie par e-mail.",
    content:
      'Conditions générales de Bridgestone CHFope NV/SA, Netherlands Branch, dont le siège social est situé à Nieuwe Weideweg1 NL- 6121 PD Born Netherlands - K.v.K. 66469767 (ci-après dénommé "Bridgestone").',
    point1Title: "Participation",
    point1Desc:
      "Les conditions générales n'impliquent aucun engagement de la part du Participant à atteindre une part de marché fixée par Bridgestone, ni n'obligent le Participant à vendre exclusivement les pneus de Bridgestone. <br/>Il est entendu que les Participants restent libres de déterminer lCHFs propres prix de revente des pneus sans aucune restriction, même en présence de recommandations, qui doivent toutefois être considérées comme non contraignantes. <br/>Les conditions de participation à BS PLUS qui sont contraignantes pour l'entreprise participante avec laquelle l'accord a été conclu (ci-après dénommée \"Participant\"). Le Participant reconnaît que l'admission à la participation à BS PLUS est à la discrétion de Bridgestone et qu'aucune réclamation à l'encontre de Bridgestone pour cette admission n'est valable. Le transfert ou l'attribution de comptes de participant est expressément interdit, sauf indication contraire de Bridgestone. L'abandon du Compte Participant n'est pas autorisé. <br/>Les participants sont responsables de la mise à jour rapide de lCHFs données personnelles en ligne. Le non-respect de cette obligation peut entraîner des coûts supplémentaires, des retards, un risque accru de dommages ou de perte de prix, ainsi que d'autres prix associés.",
    point2Title: "Frais de kickback et crédit de points marketing",
    point2Desc:
      "Le niveau d'entrée pour le paiement est que le Participant achète un volume minimum de soixante (60) voitures, camions légers, 4x4 d'été, d'hiver et toutes saisons de marque Bridgestone chez les distributCHFs sélectionnés du 1er avril 2024 au 31 décembre 2024. Si le volume annuel minimum n'est pas atteint, aucun kickback ne sera crédité au Participant. À partir de 2025, le niveau d'entrée pour le paiement sera de cent vingt (120) voitures, camions légers, 4x4 d'été, d'hiver et toutes saisons de marque Bridgestone chez les distributCHFs sélectionnés du 1er janvier au 31 décembre. <br/>Périodes concernées par les points et périodes de comptabilisation pour le calcul des points à partir de 2025 : janvier - décembre de chaque année. <br/>Les frais de kick-back et les points marketing ne s'appliquent pas aux produits 2A, aux pneus de démonstration, aux EAN non actifs/inactifs... Les points non utilisés de l'année précédente expirent au mois de mars de l'année suivante. Par exemple, les points non utilisés de 2024 expirent le 01 mars 2025. <br/>Les points seront crédités au participant uniquement à l'initiation de Bridgestone et en stricte conformité avec les conditions énoncées dans l'onglet Conditions de la plateforme Bridgestone plus. Le nombre de points accordés par type de pneu est accessible sur la plateforme BS. https://plus.bridgestone.nl",
    point3Title: "Récompenses",
    point31Title: "Points marketing",
    point31Desc:
      "Le Participant a désigné un employé ou un agent vicaire pour récupérer les récompenses en son nom. Cette personne a accès au compte de points du Participant. <br/>Les participants ont la possibilité d'échanger les points crédités contre des récompenses offertes en nature et/ou en services. Le paiement de la valCHF en espèces équivalente des points accumulés n'est pas autorisé, sauf si cela est expressément indiqué dans le système de récompenses. Aucun intérêt ne s'accumule sur le compte du participant. Les points peuvent être remboursés si le compte de points présente le solde nécessaire pour la récompense spécifique. Les participants n'ont pas de droit garanti à une récompense particulière, et le remboursement est soumis à la disponibilité pendant la durée de validité des stocks. <br/>Le participant a la possibilité de rembourser les points crédités pour les récompenses offertes en nature et/ou en services. Le paiement de la valCHF en espèces équivalente des points collectés n'est pas autorisé, sauf si cela est expressément indiqué dans le système de récompenses. Aucun intérêt n'est versé sur le compte du participant. Les points collectés peuvent être remboursés si le compte de points présente le solde nécessaire pour la récompense spécifique. Les participants n'ont pas de droit garanti à une récompense particulière, et le remboursement est soumis à la disponibilité des stocks restants. <br/>Bridgestone se réserve le droit de rectifier toute errCHF manifeste d'étiquetage des récompenses. Les points mis en jeu ne sont pas transférables et ne peuvent pas être échangés contre des points supplémentaires ou d'autres récompenses. Une fois la commande passée, le Participant recevra rapidement une confirmation de réception.  Bridgestone vérifiera alors rapidement toutes les données pertinentes et évaluera la disponibilité de la récompense. Sauf mention contraire explicite, toutes les performances, dimensions des prix restent telles que décrites. <br/>Les points mis en jeu ne peuvent pas être échangés contre des points ou des récompenses. Une fois la commande passée, le participant recevra rapidement une confirmation de réception. Bridgestone vérifiera alors rapidement toutes les données pertinentes et la disponibilité de la récompense. Sauf mention contraire explicite, toutes les spécifications de performances, de dimensions, de poids et de taille sont approximatives et sont fournies à des fins descriptives uniquement ; elles ne constituent pas des propriétés garanties. Les délais de livraison seront communiqués séparément au Participant après que la commande aura été passée. Dans le cas où l'article commandé est indisponible ou ne peut être livré, Bridgestone se réserve le droit d'envoyer au Participant un article similaire ou d'annuler la commande. <br/>Les points marketing doivent être utilisés par le Participant avant le 31 mars de l'année suivante, sinon ils seront annulés.",
    point32Title: "Frais de kickback",
    point32Desc:
      "Le Participant recevra un kickback fees après la réalisation des engagements pris, soit directement de Bridgestone, soit d'un fournissCHF de services sélectionné. <br/>La commission de rétrocession s'accumule lorsque les conditions de participation sont acceptées par le participant par le biais de commandes de pneus facilitées par des distributCHFs désignés par Bridgestone. Bridgestone ou un prestataire de services sélectionné discute les frais de kickback avec le Participant une fois par an, suite à une vérification de l'exactitude des données collectées et sous réserve de la réalisation des engagements susmentionnés. Ce remboursement intervient au cours du premier trimestre de l'année suivante. Par exemple, la prime de kickback pour l'année 2024 est annulée au cours du premier trimestre 2025. <br/>Ce processus est exécuté automatiquement après un examen complet des commandes de pneus et des données associées du Participant. Le Participant recevra les commissions de remboursement directement de Bridgestone ou d'un prestataire de services sélectionné. Concurrently, the Participant will be provided with a document suitable for inclusion in its financial records.",
    point4Title: "SCORE / MOT DE PASSE",
    point4Desc:
      "Les points sont enregistrés sous le numéro du participant. Toute objection à l'exactitude ou à l'exhaustivité du score doit être formulée par écrit dans un délai d'un mois à compter de la prise de connaissance de l'objection. Le fait de ne pas soulever d'objection dans les délais impartis vaut approbation du score. Même après l'expiration du délai, une correction du score indiqué peut être demandée si le Participant peut démontrer de manière non équivoque l'inexactitude et/ou l'incomplétude. Il est de la responsabilité du Participant de s'assurer que son mot de passe reste confidentiel, et en cas de suspicion qu'une autre personne ait eu connaissance du mot de passe ou de toute autre utilisation abusive, le Participant doit changer rapidement son mot de passe ou en informer rapidement Bridgestone.",
    point5Title: "DEFECTS/DÉFAUTS",
    point5Desc:
      "Les défauts dans les articles livrés doivent être signalés immédiatement par écrit. Dans le cas contraire, les dispositions statutaires s'appliquent.",
    point6Title: "DATE",
    point6Desc:
      "La participation à BS PLUS est volontaire et les participants peuvent choisir de mettre fin à lCHF participation à tout moment en en informant Bridgestone. Il est important de noter que l'annulation de la participation n'a pas d'incidence sur le remboursement des points accumulés. Bridgestone se réserve le droit d'exclure un participant du programme pour des raisons justifiables.",
    point7Title: "LIABILITY",
    point7Desc:
      "Le Participant assume à ses propres risques toutes les obligations liées à son organisation commerciale concernant, par exemple, les relations d'emploi et d'auto-emploi, y compris les obligations d'assurance, la bonne gestion fiscale et administrative de l'entreprise, et le respect des réglementations actuelles en matière d'environnement, de sécurité et de prévention des accidents. <br/>Sauf en cas de faute intentionnelle ou de négligence grave, Bridgestone ne sera pas responsable de tout dommage causé par le Participant dans l'exécution des activités mentionnées dans les Conditions.",
    point8Title: "MODIFICATION DES CONDITIONS DE PARTICIPATION ET D'ORDRE",
    point8Desc:
      "Bridgestone se réserve le droit d'interrompre le système de récompenses moyennant un préavis de 3 mois, en cas de raison majCHFe également sans observer un tel délai de préavis, tout en préservant raisonnablement les intérêts du Participant. Bridgestone se réserve également le droit de modifier ou de compléter les termes et conditions dans la mesure où cela s'avère nécessaire dans l'intérêt d'un traitement plus simple et plus sûr et, en particulier, pour prévenir les abus.Le Participant sera informé à l'avance de toute modification. Une modification et/ou un complément sont réputés avoir été approuvés s'ils ne sont pas résiliés dans un délai d'un mois à compter de lCHF prise de connaissance ou si le Participant participe à nouveau au programme de récompenses après l'expiration de cette période.",
    point9Title: "CONFIDENTIALITÉ",
    point9Desc:
      "Le Participant s'engage, pour lui-même et pour ses employés et collaboratCHFs, à ne pas divulguer à des tiers et à ne pas utiliser des informations de nature confidentielle, telles que des informations techniques, des données publicitaires ou financières, des informations commerciales, des savoir-faire, des prix, des coûts, des informations administratives, des projets opérationnels présents et futurs, des stratégies Bridgestone, ou toute autre information qui n'est pas encore dans le domaine public au moment de la divulgation. Cette clause doit également être considérée comme contraignante pour les cinq années suivantes à compter de la fin de la participation.",
    point10Title: "PROTECTION DES DONNÉES",
    point10Desc:
      "Bridgestone, son prestataire de services sélectionné et le Participant s'engagent à respecter toutes les obligations prévues par le règlement (UE) 2016/679 du Parlement CHFopéen et du Conseil du 27 avril 2016 relatif à la \"protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données\" (ci-après \"RGPD\"), ainsi que les réglementations nationales pertinentes et les mesures de l'Autorité de protection des données. Pour participer à BS PLUS, diverses données personnelles doivent être collectées, stockées et utilisées. Ces données sont nécessaires pour ouvrir un compte de points personnels pour le participant et pour pouvoir lui envoyer des informations relatives au programme de récompenses. Les données obligatoires requises pour la participation comprennent le nom de l'entreprise, le prénom, le nom de famille, la position dans l'entreprise, l'adresse postale complète, le numéro de téléphone, le numéro BTW, le numéro de compte bancaire et l'adresse e-mail. Aux fins du traitement et de la mise en œuvre de BS PLUS, les données des participants seront stockées et utilisées par TAKTZEIT, Bridgestone ou une société de services mandatée par TAKTZEIT. Bridgestone et TAKTZEIT s'engagent également à respecter les dispositions légales en matière de protection des données. Les données ne sont transmises à des tiers que si ces derniers agissent en tant que mandataires, par exemple pour le traitement d'une commande de récompenses. En participant au programme de récompenses, le participant déclare son consentement en confirmant celui-ci, qui peut être révoqué par écrit à tout moment. Avec la déclaration de consentement, le Participant reçoit la newsletter correspondante. Il est possible de se désabonner de la newsletter à tout moment via l'élément de menu 'Contact &gt; Se désabonner de la newsletter'.",
    point11Title: "Propriété intellectuelle",
    point11Desc:
      "Le Participant reconnaît et accepte que tous les droits de propriété intellectuelle (ci-après dénommés \"DPI\"), présents et futurs, relatifs à, subsistant dans ou liés de quelque manière que ce soit à la BS Plus, sont la propriété du groupe Bridgestone. Le Participant est autorisé à utiliser les DPI uniquement dans le cadre de son activité de vente de pneus et de fourniture de services. Les projets de reconnaissance de points de vente internes et externes doivent être approuvés par Bridgestone. Il est entendu que si le Participant a l'intention d'utiliser les DPI dans une quelconque forme de communication au public, le matériel promotionnel et publicitaire préparé à cet effet doit être soumis à Bridgestone pour approbation préalable. Bridgestone aura le droit de vérifier à tout moment, par le biais d'une inspection sur place dans les locaux du Participant, que les règles d'utilisation des DPI sont respectées. Le Participant ne peut en aucun cas attribuer l'utilisation des DPI et/ou en disposer d'une autre manière à des tiers.",
    point12Title: "DISPOSITIONS FINALES",
    point121Desc:
      "Les modifications ou les ajouts aux présentes conditions générales doivent être faits par écrit. Ceci s'applique également à la dérogation à cette exigence de forme écrite.",
    point122Desc:
      "Le droit néerlandais s'applique à l'exclusion de la Convention des Nations Unies sur les contrats de vente internationale de marchandises. Pour tout litige lié à ou découlant de la lettre d'engagement, les parties choisissent la compétence exclusive du tribunal de Rotterdam, Pays-Bas.",
    point123Desc:
      "Si des dispositions individuelles de ces termes et conditions sont inefficaces ou contraires aux dispositions légales, cela n'affectera pas le reste du contrat.La disposition invalide sera remplacée par les parties contractantes par accord mutuel par une disposition qui se rapproche le plus du sens et de l'objectif économique de la disposition invalide d'une manière légalement efficace.",
    point1234Desc:
      "La disposition susmentionnée s'applique de la même manière en cas d'omissions ou de lacunes. Les accords verbaux sont réputés invalides et seules les conditions de participation énoncées dans les conditions générales (CG) sont considérées comme contraignantes.",
    point13Title: "RETOUR POLICY",
    point13Desc:
      "Le participant dispose d'un droit de retour de 14 jours. <br/>Dans ce cas, il/elle doit écrire à : Bridgestone CHFope NV/SA Netherlands Branch, with registered office in Nieuwe Weideweg1 NL- 6121 PD Born Netherlands. Bridgestone fournira au participant les instructions nécessaires pour le processus de retour. Le délai de retour commence à courir dès la réception des marchandises par le participant. En cas de retour d'un produit livré, l'achetCHF est responsable de la prise en charge des frais de retour si les marchandises livrées correspondent aux articles commandés. Les points utilisés par le Participant pour la récompense remboursée seront réintégrés dans le compte de points. Le droit de retour ne s'applique pas aux articles qui ont été personnalisés selon les spécifications ou qui sont clairement adaptés aux exigences personnelles.",
  },
  commitmentLetter: {
    title: "Lettre d'engagement",
    short_description: "Voer hier uw contact- en bedrijfsgegevens in.",
  },
  kickbackInfo: {
    title: "Explication des frais de kickback et des points",
    short_description:
      "Vous pouvez voir ici comment gagner des frais de kickback et des points marketing.",
    description:
      "<b>BRIDGESTONE PLUS</b> vous permet de gagner des points et de bénéficier d'un kickback sur tous les pneus Bridgestone que vous commandez auprès des revendeurs désignés par Bridgestone. Vous trouverez ci-dessous comment gagner des points et des frais de kickback. <br /><br />&gt;règles<b>:</b><ul><li>Pour chaque pneu Bridgestone, vous recevez des points marketing que vous pouvez dépenser dans la boutique. Le nombre de points que vous recevez par pneu dépend de la taille en pouces du pneu.</li><li>L'indemnité de retour s'accumule au cours de l'année grâce aux commandes de pneus passées auprès des revendeurs mandatés par Bridgestone. Bridgestone verse l'indemnité de kickback au participant une fois par an, après avoir vérifié l'exactitude des données collectées et à condition que vous ayez acheté au moins 120 pneus par an. Ce versement a lieu au cours du premier trimestre de l'année suivante. Exemple : le versement de l'indemnité de kickback pour l'année 2024 aura lieu au premier trimestre 2025. Cette opération se fait automatiquement après vérification des commandes de pneus et de vos données. Vous recevrez l'indemnité de kickback directement de Bridgestone ou par l'intermédiaire de son partenaire externe. Vous recevrez également un document prêt à être intégré dans votre gestion financière.</li></ul>",
    tableFooter:
      "Pas de frais de kick-back pour les autres groupes de produits : TBR, MC, OTR, AG",
    withdraw: "Pour le paiement du kickback fee",
  },
  pause: "PAUSE",
  myProfile: "Mon profil",
  tyreAmount: "Quantité de pneus",
  rewardsOverview: {
    titlePoints: "Points marketing (1 point = 0,25 CHF)",
    titleKickback: "Bonus de frais de kick-back en chf",
    footerPoints:
      "Pas de points de commercialisation pour les autres groupes de produits : TBR, MC, OTR, AG",
    kickbackPoints:
      "Pas de frais de kickback pour les autres groupes de produits : TBR, MC, OTR, AG",
    groupLevel: "Niveau du groupe",
  },
  group: "Groupes",
  major: "Groep",
  strategicPartners: {
    cardTitle: "Contact avec nos partenaires stratégiques",
    title: "Contacter le distributeur",
    description:
      "Nous sommes prêts pour vous ! Vous trouverez ci-dessous les détails de vos contacts grossistes.",
    short_desc:
      "Vous avez des questions concernant vos commandes de pneus chez les revendeurs affiliés ? Cliquez ci-dessous pour obtenir les coordonnées",
  },
  onlineVisibility: {
    box: {
      title: "Visibilité en ligne",
    },
    title: "Visibilité en ligne",
    description:
      "Augmentez et contrôlez votre visibilité numérique au niveau du POS avec UBERALL",
    category_title: "uberall - améliorer la visibilité digitale",
    category_description:
      "Utilisez maintenant vos points de récompense pour faire passer votre marketing numérique au niveau supérieur. Grâce à la plateforme uberall, Bridgestone aide ses partenaires commerciaux à optimiser leur présence en ligne afin de générer plus de visiteurs. Et ce, sur plus de 100 plates-formes telles que Google, Facebook, Bing ou Trustpilot.",
    content: "Profitez dès à présent des avantages d'uberall :",
    point1: "Optimisation de la visibilité en ligne",
    point2: "Commande & contrôle pratiques des emplacements POS",
    point3:
      "Suivre la visibilité locale, les évaluations et le contenu des médias sociaux",
    footer:
      "Pour obtenir des informations détaillées et vous faire une première idée d'uberall, regardez la vidéo ci-dessous.",
    period: "Durée : 1 an",
    form: {
      title: "Ainsi, vous utilisez uberall pour votre entreprise :",
      point1: "Souscrire un abonnement annuel pour 480 points",
      point2: "Après vérification interne, vous recevrez une confirmation",
      point3: "pas de renouvellement automatique",
      pointDiscount: "points dans un {price} CHF de pour les suivants",
      howMuch: "Combien de points souhaitez-vous utiliser ?",
    },
    uberall: {
      title: "ABONNEMENT UBERALL",
    },
  },
  media: {
    title: "Paquets média",
    short_description:
      "Vous trouverez ici des données pour les médias sociaux, la télévision en magasin et bien plus encore.",
    description:
      "Vous trouverez ici des images, des vidéos et des médias numériques à utiliser librement. Utilisez nos packs médias pour votre propre présence sur les médias sociaux, la télévision en magasin ou les annonces publicitaires digitale.",
  },
  sortBy: {
    default: "Trier par",
    desc: "Trier par : Derniers",
    asc: "Trier par : Plus ancien",
    name: "Namen",
    date: "Datum",
    choiceBy: "Auswahl sortieren nach",
  },
  bridgestoneProductBrochures: {
    title: "Produits Bridgestone",
    description:
      "Téléchargez ici les brochures et dépliants actuels sur nos pneus Bridgestone pour voitures particulières, SUV et camionnettes.",
    files: {
      desc1: "Voiture, SUV - Hiver",
    },
  },
  testResult: "Résultats des tests",
  productOverview: "Aperçu des produits",
  summary: "Résumé",
  information: "Information",
  brochure: "Brochure",
  makeChoice: "Faites votre choix ici",
  winterIn: "L'hiver est là",
  summerIn: "Vers l'été",
  allSeasonIn: "Toute la saison",
  haveQuestion: "Vous avez une question ?",
  contactUs: "N'hésitez pas à nous envoyer un e-mail à",
  at: "chez",
  tyreBox: {
    title: "Pneus",
    totalAmount: "Total des pneus",
    target: "Votre cible",
    entry: "Votre entrée",
  },
  languageSelect: {
    title:
      "Welcome to <b>BRIDGESTONE PLUS</b> - the premium portal from Bridgestone.",
    label: "Language Selection",
    description:
      "Bitte wählen Sie Ihre Sprache/ Veuillez choisir votre langue/ Selezionare la lingua",
  },
  current_tyres_amount: "Montant des pneus",
  current_points: "Score",
  current_kickbacks: "Kick-back",
  mediaCategories: {
    products: "Produkte",
    brand_and_solutions: "Marke & Lösungen",
    season_and_promotions: "Saison & Aktionen",
    format: "Format",
    cars_and_vans: "Pkw & Transporter",
    truck_and_buses: "Lkw & Bus",
    motorcycle: "Motorrad",
    agriculture: "Landwirtschaft",
    construction_machinery: "Baumaschinen",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    summer: "Sommer",
    winter: "Winter",
    all_season: "All Season",
    promotions: "Aktionen",
    video_in_store: "Video (Instore)",
    video_online: "Video (Online)",
    banner_website: "Banner (Webseite)",
    banner_social_media: "Banner (Social Media)",
    logos: "Logos",
    b_drive: "B-drive",
    media_library: "Media library",
    media_packages: "Media packages",
  },
  placeholders: {
    searchMedia: "Entrez un terme de recherche",
  },
  searchResults: "Résultats de recherche",
  setFilters: "Bitte setzen Sie Ihre Auswahlfilter",
  kickbackExchange: {
    title: "Échange de pots-de-vin",
    description:
      "Veuillez saisir le montant des frais que vous souhaitez échanger<sup>*</sub>:",
    disclaimer: "Niveau d'entrée: {tyres} pneus nécessaires",
    afterExchange: "Votre relevé de compte après échange:",
  },
  productSearchBox: {
    from: "à partir de la valeur des points",
    to: "points tojusqu'à la valeur en points",
  },
  validators: {
    min_money: "Field must be greater then {min} €",
    max_money: "Field must be lower then {max} €",
  },
  subMediaPage: {
    description:
      "Bienvenue dans l'espace média consacré aux produits Bridgestone et Firestone. Vous trouverez ici des images de produits actuelles, des logos ainsi que de nombreuses bannières, vidéos et modèles numériques à utiliser, par exemple. B. sur votre site Web ou sur les réseaux sociaux.",
  },
  brochure_prices: {
    description:
      "Téléchargez ici les dernières brochures, dépliants et listes de prix de nos pneus Bridgestone et Firestone pour voitures, SUV et camionnettes.",
  },
  brochureCategories: {
    products: "Produits",
    brand_and_solutions: "Marque & Solutions",
    season_and_promotions: "Saison & Promotions",
    format: "Format",
    cars_and_vans: "Voitures et utilitaires",
    summer: "Été",
    winter: "Hiver",
    promotions: "Promotions",
    all_season: "Toutes saisons",
    truck_and_buses: "Camions et bus",
    motorcycle: "Motocycle",
    agriculture: "Agriculture",
    construction_machinery: "Matériel de construction",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Matériaux",
    brochures: "Brochures",
    price_list: "Liste de prix",
    materials: "Matériaux",
  },
  favoriteProducts: {
    description: "Vous trouverez ici les produits que vous avez enregistrés.",
  },
  multiplicator: {
    title: "Multiplicateur de bonus",
    bandBonusTitle: "Bonus par pneu au multiplicateur",
    amountLabel: "Nombre min. de pneus (*)",
    label: "Multiplicateur de bonus",
    desc: "Nombre de pneus Bridgestone et Firestone. Il n’y a pas de bonus en euros sur les pneus Firestone.",
    goals: {
      loyal: "Fidèle",
      bronze: "Bronze",
      silver: "Argent",
      gold: "Or",
      platinum: "Platine",
    },
    andMore: "et plus",
    chooseTarget: "Sélectionner",
    selectTarget: "Sélectionnez ici votre objectif annuel {year} :",
    multiplication: "Le bonus est multiplié par <b>{factor}</b>",
    minTyres: "<b>Minimum :</b> {tyre} pneus",
  },
  validation: {
    participantCount: {
      max: "{field} ne peut pas dépasser {max}",
    },
    setPoints: {
      max: "Vous disposez d’un total de {max} points",
    },
    default: "{field} ne peut pas dépasser {max}",
  },
};
